<template>
  <div
    class="tva-dropdown-container"
    ref="dropdownContainer"
    :style="{
      '--item-height': itemHeight,
      '--content-height': content.length * itemHeight + (content.length - 1),
    }"
  >
    <!-- + content.length for borders -->
    <div class="dropdown-label" v-if="label" v-html="label"></div>
    <button
      :class="[
        'tva-dropdown-button',
        { open: dropdownOpen, selected: selectedEl },
      ]"
      @click="toggleDropdown"
    >
      <div class="tva-dropdown-button-container">
        <span>{{
          selectedEl ? selectedEl.label : placeholder
        }}</span>
        <icon
          class="tva-dropdown-button-container__icon"
          :data="selectedEl ? close : arrowDownSmall"
          width="1rem"
        />
      </div>
    </button>

    <div :class="['tva-dropdown-content', dropdownOpen ? 'open' : '']">
      <ul>
        <li
          v-for="(child, childIndex) in content"
          :key="childIndex"
          :class="{
            selected: selectedEl && child.id === selectedEl.id,
          }"
        >
          <button @click="selectElement(child)">
            <slot :id="child.id"></slot>
            <span>{{ child.label }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { onClickOutside } from "@vueuse/core";
import { arrowDownSmall, close } from "@/assets/icons/icons.js";

export default {
  props: {
    content: {
      type: Array,
      default: () => [],
    },
    label: { type: String, default: null },
    placeholder: String,
    selectedElement: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedEl: this.selectedElement,
      dropdownOpen: false,
      itemHeight: 42,
      arrowDownSmall,
      close,
    };
  },
  methods: {
    selectElement(element) {
      this.$emit("select", element);
      this.selectedEl = element;
      this.dropdownOpen = false;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    toggleDropdown() {
      if (this.selectedEl) {
        this.$emit("select", null);
      } else {
        this.dropdownOpen = !this.dropdownOpen;
      }
      
    },
  },
  watch: {
    selectedElement(selectedElement) {
      this.selectedEl = selectedElement;
    },
  },
  mounted() {
    this.$nextTick(() =>
      onClickOutside(this.$refs.dropdownContainer, this.closeDropdown)
    );
  },
};
</script>

<style lang="scss" scoped>
.tva-dropdown-container {
  position: relative;
  user-select: none;
  width: 100%;
  font-family: "EniTabBold";
  font-size: toRem(12);
  line-height: toRem(14);
  z-index: 3;

  .dropdown-label {
    margin-bottom: 0.5em;
  }
  .tva-dropdown-button {
    width: 100%;
    display: inline-block;
    height: toRem(34);
    position: relative;
    background-color: var(--white-100);
    border-radius: 6px;
    text-transform: uppercase;
    transition: background-color 0.3s;
    cursor: pointer;

    &-container {
      width: 100%;
      height: 100%;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: toRem(14);

      &__icon {
        margin: 0 0.5rem;
      }

      .svg-icon {
        transform-origin: center;
        transition: transform 0.5s ease;
      }
    }
    &.open {
      .tva-dropdown-button-container {
        &::after {
          opacity: 1;
        }
        .tva-dropdown-button-container__icon {
          transform: rotate(-180deg);
        }
      }
    }

    &.selected {
      background-color: var(--selected-color, var(--primary-yellow));
    }
  }

  .tva-dropdown-content {
    overflow: hidden;
    position: absolute;
    top: calc(100% + 1rem);
    left: 0;
    width: 100%;
    display: inline-block;
    background-color: var(--white-100);
    border-radius: 6px;
    padding-bottom: 0;
    transition: padding-bottom 0.5s ease;

    &.open {
      padding-bottom: toRem(var(--content-height));
    }

    ul {
      position: absolute;
      left: 0;
      bottom: 0;
      list-style-type: none;
      padding: 0;
      margin: 0;
      width: 100%;

      li {
        width: 100%;
        border-bottom: solid 1px var(--scala-grigi-gray-3);
        transition: background-color 0.3s;

        &:last-child {
          border-bottom: none;
        }

        button {
          width: 100%;
          height: toRem(var(--item-height));
          padding: 0 toRem(14);
          display: flex;
          align-items: center;
          text-transform: uppercase;
          cursor: pointer;
        }

        &.selected {
          background-color: var(--selected-color, var(--primary-yellow-light));
        }
      }
    }
  }
}
</style>
